import { render, staticRenderFns } from "./MensagenPronta.vue?vue&type=template&id=1e486def&scoped=true"
import script from "./MensagenPronta.vue?vue&type=script&lang=js"
export * from "./MensagenPronta.vue?vue&type=script&lang=js"
import style0 from "./MensagenPronta.vue?vue&type=style&index=0&id=1e486def&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e486def",
  null
  
)

export default component.exports